export default "__VITE_ASSET__DT3PrZQu__"